import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef
} from 'react';
import styled from '@emotion/styled';

import { Button, Field, Input } from '../../../../main/scripts/lumen';

export const LoginForm = forwardRef(
  (
    {
      onLogin,
      loading,
      username,
      onChangeUsername,
      password,
      onChangePassword,
      belowFields
    },
    ref
  ) => {
    const usernameRef = useRef();
    const passwordRef = useRef();

    const focus = () => {
      if (username === '') {
        usernameRef.current?.focus();
      } else {
        passwordRef.current?.focus();
      }
    };

    useImperativeHandle(ref, () => ({ focus }));

    useEffect(() => {
      focus();
    }, []);

    return (
      <Form
        onSubmit={event => {
          event.preventDefault();
          onLogin();
        }}
      >
        <Fields>
          <Field label="User Name" htmlFor="login-username">
            <Input
              id="login-username"
              ref={usernameRef}
              aria-label="username"
              name="username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={event => onChangeUsername(event.target.value)}
            />
          </Field>
          <Field label="Password" htmlFor="login-password">
            <Input
              id="login-password"
              ref={passwordRef}
              aria-label="password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={event => onChangePassword(event.target.value)}
            />
          </Field>
        </Fields>
        {belowFields}
        <Button
          type="submit"
          variant="primary"
          size="md"
          disabled={loading}
          aria-busy={loading}
          style={{ width: '100%' }}
        >
          {loading ? 'Logging in...' : 'Login'}
        </Button>
      </Form>
    );
  }
);

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;
